// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_DetalheInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** Chamados_DetalheInput — GET /chamados/detalhe?id=N. */
import { registerContract } from './validate'

export interface Chamados_DetalheInput {
id: number
}

registerContract('Chamados_DetalheInput', {
  id: { type: 'number',  required: true },
})
